export default {
  cacheKey    : null,
  messages    : [],
  totalCount  : 0,
  unreadCount : 0,
  fetchedAt   : 0,
  isLoading   : false,
  error       : null,
  readError   : null,
  revision    : 0
}
